// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__zSTUo","text":"Header_text__wd3fL","buttons":"Header_buttons__2cjce","menyuButton":"Header_menyuButton__26elE"};